import { blockedOptionMessage } from '@utils/Index.jsx';

/**
 * Retorna props comuns de label, placeholder e disabled conforme o campo e o tipo de cadastro.
 * @param {'nome'|'sigla'|'numero'|'gerente'|'encarregado'|'go'|'porte'} field
 * @param {{ value: string } | null} selectedOptionTypeRegistration
 */
export function getFieldPropertiesCreate(field, selectedOptionTypeRegistration) {
  const type = selectedOptionTypeRegistration?.value; // "UNIDADE" ou "GERENCIA"

  const genericLabels = {
    nome: 'Nome',
    sigla: 'Sigla',
    numero: 'Número',
    gerente: 'Gerente',
    encarregado: 'Encarregado',
    go: 'GO (Unidade)',
    porte: 'Porte (Unidade)',
  };

  const fieldLabels = {
    nome: type === 'UNIDADE' ? 'Nome da Unidade' : 'Nome da Gerência',
    sigla: type === 'UNIDADE' ? 'Sigla da Unidade' : 'Sigla da Gerência',
    numero: type === 'UNIDADE' ? 'Número da Unidade' : 'Número da Gerência',
    gerente: 'Gerente',
    encarregado: 'Encarregado',
    go: 'GO (Unidade)',
    porte: 'Porte (Unidade)',
  };

  // Se não escolheu tipo, tudo fica desabilitado
  if (!type) {
    return {
      isDisabled: true,
      placeholder: blockedOptionMessage,
      label: genericLabels[field] || field,
    };
  }

  // Campos que só valem para UNIDADE
  if (field === 'go' || field === 'porte') {
    return {
      isDisabled: type !== 'UNIDADE',
      placeholder: type === 'UNIDADE' ? 'Selecione uma opção' : blockedOptionMessage,
      label: fieldLabels[field],
    };
  }

  // Selects de gerente e encarregado
  if (field === 'gerente' || field === 'encarregado') {
    return {
      isDisabled: false,
      placeholder: `Selecione um ${genericLabels[field].toLowerCase()}`,
      label: fieldLabels[field],
    };
  }

  // Demais inputs de texto
  return {
    isDisabled: false,
    placeholder: `Inserir ${fieldLabels[field].toLowerCase()}`,
    label: fieldLabels[field],
  };
}
